<template lang="pug">
  div 
</template>

<script>
// @ is an alias to /src
export default {
  name: 'logout',
  components: {
  },
  data() {
    return {
      email: '',
      password: '',
      msg:null,
    }
  },
  methods:{

  },    
  created(){
    this.flash('Logging Out...','success')
    this.axios.get(`/rp/server/logout`)
    .then((response) => {
      if(response.data.success){
        this.$router.push({ path: '/login'});        
      }else if(response.data.error){
        this.flash( response.data.error,'warning')
      }
    })
    .catch(error => {
      this.flash(error,'warning')
    })      
  }
}
</script>

<style lang="scss">
 
</style>
